module.exports = __webpack_public_path__ + "img/OPL@3x.ca29a373.png";